<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Executive Summary</div>

    <div class="divider"></div>
    <div class="dates">
      <div class="date start-date">
        <div class="text">Start</div>
        <button
          mat-button
          class="icon-btn"
          (click)="startDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #startDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="startDate"
        >
        </lhpe-datepicker>
      </div>
      <div class="date end-date">
        <div class="text">End</div>
        <button
          mat-button
          class="icon-btn"
          (click)="endDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #endDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="endDate"
        >
        </lhpe-datepicker>
      </div>
    </div>
  </div>
  <div class="header-center"></div>
  <div class="header-right"></div>
</div>
<div class="exec-summ">
  <div class="column">
    <div class="container icon-info-container installs-container">
      <div class="container-header no-bottom-border">
        <div class="text">Total installs</div>
      </div>

      <div class="container-content">
        <div class="row">
          <div class="icon">
            <svg-icon src="assets/svg/exec-summary/installs.svg"></svg-icon>
            <div class="text">{{ totalInstalls ? totalInstalls : "0" }}</div>
          </div>
          <div class="graph">
            <div
              echarts
              [options]="totalInstallsChartOptions"
              class="bar-chart"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div class="container icon-info-container registration-container">
      <div class="container-header no-bottom-border">
        <div class="text">User registrations</div>
        <!-- <div class="options">
          <button mat-icon-button [matMenuTriggerFor]="registrationsMenu">
            <svg-icon src="assets/svg/ellipsis-white.svg"></svg-icon>
          </button>
          <mat-menu class="mat-menu-elaphant #registrationsMenu="matMenu">
          </mat-menu>
        </div> -->
      </div>

      <div class="container-content">
        <div class="row">
          <div class="icon">
            <svg-icon src="assets/svg/exec-summary/registration.svg"></svg-icon>
            <div class="text">{{ totalRegistrations }}</div>
          </div>
          <div class="graph">
            <div
              echarts
              [options]="userRegistrationsChartOptions"
              class="bar-chart"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div class="container icon-info-container prop-visits-container">
      <div class="container-header no-bottom-border">
        <div class="text">Average number of On Property visits</div>
        <!-- <div class="options">
          <button mat-icon-button [matMenuTriggerFor]="propVisitsMenu">
            <svg-icon src="assets/svg/ellipsis-white.svg"></svg-icon>
          </button>
          <mat-menu class="mat-menu-elaphant" #propVisitsMenu="matMenu">
          </mat-menu>
        </div> -->
      </div>

      <!-- <div class="container-content">
        <div class="row">
          <div class="icon">
            <svg-icon src="assets/svg/exec-summary/prop-visits.svg"></svg-icon>
            <div class="text">Text</div>
          </div>
          <div class="graph">
            <div
              echarts
              [options]="avgNumberOnPropVisitsChartOptions"
              class="bar-chart"
            ></div>
          </div>
        </div>
      </div> -->

      <div class="container-content">
        <div class="row">
          <div class="icon">
            <svg-icon src="assets/svg/exec-summary/prop-visits.svg"></svg-icon>
          </div>
          <div class="data">
            <div class="number white">
              {{ averageLocationVisits | number: "1.2-2" }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="column">
    <div class="container icon-info-container location-allowed-container">
      <div class="container-header no-bottom-border">
        <div class="text">
          Mobile location {{ mobileLocationOption | lowercase }}
        </div>
        <!-- <div class="options">
          <button mat-icon-button [matMenuTriggerFor]="locationAllowedMenu">
            <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
          </button>
          <mat-menu class="mat-menu-elaphant" #locationAllowedMenu="matMenu">
            <mat-radio-group
              class="mat-lightGreen"
              aria-label="Select an option"
              [(ngModel)]="mobileLocationOption"
            >
              <mat-radio-button value="Allowed" class="mat-lightGreen"
                >Allowed</mat-radio-button
              >
              <mat-radio-button value="Preffered" class="mat-lightGreen"
                >Preffered</mat-radio-button
              >
            </mat-radio-group>
          </mat-menu>
        </div> -->
      </div>

      <div class="container-content">
        <div class="row">
          <div class="icon">
            <svg-icon
              src="assets/svg/exec-summary/mobile-location.svg"
            ></svg-icon>
          </div>
          <div class="graph">
            <div
              echarts
              [options]="mobileLocationChartOption"
              class="pie-chart"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="container icon-info-container mobile-push-container">
      <div class="container-header no-bottom-border">
        <div class="text">Mobile push {{ mobilePushOption | lowercase }}</div>
        <!-- <div class="options">
          <button mat-icon-button [matMenuTriggerFor]="mobilePushMenu">
            <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
          </button>
          <mat-menu class="mat-menu-elaphant" #mobilePushMenu="matMenu">
            <mat-radio-group
              class="mat-lightGreen"
              aria-label="Select an option"
              [(ngModel)]="mobilePushOption"
            >
              <mat-radio-button value="Allowed" class="mat-lightGreen"
                >Allowed</mat-radio-button
              >
              <mat-radio-button value="Preffered" class="mat-lightGreen"
                >Preffered</mat-radio-button
              >
            </mat-radio-group>
          </mat-menu>
        </div> -->
      </div>

      <div class="container-content">
        <div class="row">
          <div class="icon">
            <svg-icon src="assets/svg/exec-summary/mobile-push.svg"></svg-icon>
          </div>
          <div class="graph">
            <div
              echarts
              [options]="mobilePushChartOptions"
              class="pie-chart"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="container icon-info-container">
      <div class="container-header no-bottom-border">
        <div class="text">Browser push {{ browserPushOption | lowercase }}</div>
        <div class="options">
          <button mat-icon-button [matMenuTriggerFor]="browserPushMenu">
            <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
          </button>
          <mat-menu class="mat-menu-elaphant" #browserPushMenu="matMenu">
            <mat-radio-group
              class="mat-lightGreen"
              aria-label="Select an option"
              [(ngModel)]="browserPushOption"
            >
              <mat-radio-button value="Allowed" class="mat-lightGreen"
                >Allowed</mat-radio-button
              >
              <mat-radio-button value="Preffered" class="mat-lightGreen"
                >Preffered</mat-radio-button
              >
            </mat-radio-group>
          </mat-menu>
        </div>
      </div>

      <div class="container-content">
        <div class="row">
          <div class="icon">
            <svg-icon src="assets/svg/exec-summary/browser-push.svg"></svg-icon>
          </div>
          <div class="data">
            <div class="number blue">297</div>
            <div class="info">7.6% of the active customer base</div>
          </div>
        </div>
      </div>
    </div> -->
  </div>

  <div class="column">
    <div class="container on-prop-visit-freq-container">
      <div class="container-header no-bottom-border">
        <div class="text">{{ visitFrequencyPrefix }} Visit Frequency</div>
        <div class="options">
          <button mat-icon-button [matMenuTriggerFor]="visitFrequencyMenu">
            <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
          </button>
          <mat-menu
            class="mat-menu-elaphant vertical-menu"
            #visitFrequencyMenu="matMenu"
          >
            <mat-radio-group
              class="mat-lightGreen"
              aria-label="Select an option"
              [(ngModel)]="visitFrequencyType"
            >
              <mat-radio-button value="on_property" class="mat-lightGreen"
                >On Property</mat-radio-button
              >
              <mat-radio-button value="off_property" class="mat-lightGreen"
                >Off Property</mat-radio-button
              >
            </mat-radio-group>
          </mat-menu>
        </div>
      </div>
      <div class="container-content">
        <div class="row">
          <div class="graph">
            <div class="header">
              Visits <span class="customers">Number of customers</span>
            </div>
            <div
              echarts
              *ngIf="visitFrequencyType === 'on_property'"
              [options]="onPropVisitFreqOptions"
              class="bar-chart"
            ></div>
            <div
              echarts
              *ngIf="visitFrequencyType === 'off_property'"
              [options]="offPropVisitFreqOptions"
              class="bar-chart"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="container icon-info-container">
      <div class="container-header no-bottom-border">
        <div class="text">Email subscribers</div>
        <div class="options">
          <button mat-icon-button [matMenuTriggerFor]="emailMenu">
            <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
          </button>
          <mat-menu class="mat-menu-elaphant" #emailMenu="matMenu"> </mat-menu>
        </div>
      </div>

      <div class="container-content">
        <div class="row">
          <div class="icon">
            <svg-icon src="assets/svg/exec-summary/email.svg"></svg-icon>
          </div>
          <div class="data">
            <div class="number green">2,760</div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
  <div class="column">
    <div class="container off-property-visits-container">
      <div class="container-header no-bottom-border">
        <div class="text">{{ propertyPrefix }} {{ propertySuffix }}</div>
        <div class="options">
          <button mat-icon-button [matMenuTriggerFor]="offPropertyVisitsMenu">
            <svg-icon src="assets/svg/ellipsis-white.svg"></svg-icon>
          </button>
          <mat-menu class="mat-menu-elaphant" #offPropertyVisitsMenu="matMenu">
            <mat-radio-group
              class="mat-lightGreen"
              aria-label="Select an option"
              [(ngModel)]="propertyType"
            >
              <mat-radio-button value="on_property" class="mat-lightGreen"
                >On Property</mat-radio-button
              >
              <mat-radio-button value="off_property" class="mat-lightGreen"
                >Off Property</mat-radio-button
              >
            </mat-radio-group>

            <mat-radio-group
              class="mat-lightGreen"
              aria-label="Select an option"
              [(ngModel)]="propertyValueType"
              (change)="sortProperies()"
            >
              <mat-radio-button value="visits" class="mat-lightGreen"
                >Visits</mat-radio-button
              >
              <mat-radio-button value="avg_tos" class="mat-lightGreen"
                >Avg TOS</mat-radio-button
              >
            </mat-radio-group>
            <mat-radio-group
              class="mat-lightGreen"
              aria-label="Select an option"
              [(ngModel)]="propertySortType"
              (change)="sortProperies()"
            >
              <mat-radio-button value="high_to_low" class="mat-lightGreen"
                >High to Low</mat-radio-button
              >
              <mat-radio-button value="low_to_high" class="mat-lightGreen"
                >Low to High</mat-radio-button
              >
            </mat-radio-group>
          </mat-menu>
        </div>
      </div>

      <div *ngIf="propertyType === 'off_property'" class="container-content">
        <div *ngFor="let property of offProperty" class="field">
          <div class="info">
            <div class="message">{{ property.name }}</div>
            <div *ngIf="propertyValueType === 'avg_tos'" class="amt">
              {{ property.total_avg_mins }} of {{ offPropertyAVGTotal }} minutes
            </div>
            <div *ngIf="propertyValueType === 'visits'" class="amt">
              {{ property.visits_num }} of {{ offPropertyVisitsTotal }}
            </div>
          </div>
          <div class="bar">
            <div class="bar-background"></div>
            <div
              *ngIf="propertyValueType === 'avg_tos'"
              class="bar-progress"
              [ngStyle]="{
                'width.%': (property.total_avg_mins / offPropertyAVGTotal) * 100
              }"
            ></div>
            <div
              *ngIf="propertyValueType === 'visits'"
              class="bar-progress"
              [ngStyle]="{
                'width.%': (property.visits_num / offPropertyVisitsTotal) * 100
              }"
            ></div>
          </div>
        </div>
      </div>
      <div *ngIf="propertyType === 'on_property'" class="container-content">
        <div *ngFor="let property of onProperty" class="field">
          <div class="info">
            <div class="message">{{ property.name }}</div>
            <div *ngIf="propertyValueType === 'avg_tos'" class="amt">
              {{ property.total_avg_mins }} of {{ onPropertyAVGTotal }} minutes
            </div>
            <div *ngIf="propertyValueType === 'visits'" class="amt">
              {{ property.visits_num }} of {{ onPropertyVisitsTotal }}
            </div>
          </div>
          <div class="bar">
            <div class="bar-background"></div>
            <div
              *ngIf="propertyValueType === 'avg_tos'"
              class="bar-progress"
              [ngStyle]="{
                'width.%': (property.total_avg_mins / onPropertyAVGTotal) * 100
              }"
            ></div>
            <div
              *ngIf="propertyValueType === 'visits'"
              class="bar-progress"
              [ngStyle]="{
                'width.%': (property.visits_num / onPropertyVisitsTotal) * 100
              }"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
